var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemostration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#02AF92"
    },
    d: "M501.459,183.129C470.073,77.247,372.065,0,256,0C114.616,0,0,114.616,0,256 c0,129.035,95.474,235.755,219.629,253.417L501.459,183.129z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#02967D"
    },
    d: "M512,256c0-25.32-3.694-49.773-10.541-72.871l-82.955-82.955L113.889,403.676l105.74,105.74 C231.512,511.106,243.651,512,256,512C397.385,512,512,397.385,512,256z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.808,
    y: 241.189,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 538.3426 501.9414)",
    style: {
      fill: "#02967D"
    },
    width: 98.815,
    height: 242.552
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A534A"
    },
    d: "M406.261,205.913v72.348L456.348,256C456.348,228.338,433.923,205.913,406.261,205.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263230"
    },
    d: "M406.261,256v50.087c27.662,0,50.087-22.424,50.087-50.087H406.261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 278.261,
    style: {
      fill: "#FFFFFF"
    },
    width: 55.652,
    height: 89.043
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263230"
    },
    points: "111.304,311.652 133.565,411.826 161.391,411.826 161.391,311.652 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A534A"
    },
    d: "M105.739,311.652V384c0,15.368,12.458,27.826,27.826,27.826V311.652H105.739z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#616F6D"
    },
    points: "385.113,100.174 373.983,278.261 418.504,256 418.504,100.174 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#394B48"
    },
    points: "373.983,256 385.113,411.826 418.504,411.826 418.504,256 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "200.348,178.087 178.087,278.261 385.113,256 385.113,100.174 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B1EAE5"
    },
    points: "178.087,256 200.348,333.913 385.113,411.826 385.113,256 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1A534A"
    },
    points: "44.522,200.348 44.522,256 89.043,278.261 89.043,200.348 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.522,
    y: 256,
    style: {
      fill: "#263230"
    },
    width: 44.522,
    height: 55.652
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B0B7B6"
    },
    points: "66.783,178.087 66.783,256 133.565,278.261 200.348,256 200.348,178.087 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.783,
    y: 256,
    style: {
      fill: "#889391"
    },
    width: 133.565,
    height: 77.913
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemostration);
export default __webpack_public_path__ + "static/media/demostration.6a7f4250ced6b87a52bed252c754fb14.svg";
export { ForwardRef as ReactComponent };